var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasMapTerms)?_c('a',{staticClass:"footer-link",on:{"click":_vm.$_showMapTerms}},[_vm._v(_vm._s(_vm.$t('mapDataLink')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }